module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/ecommerce-header-style2/ecommerce-header-style2.component.scss
// module id = ./src/app/features/headers-styles/ecommerce-header-style2/ecommerce-header-style2.component.scss
// module chunks = main